var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}},[_c('path',{attrs:{"d":"M20 8v6h4.43l-6.86 16H12v6h16v-6h-4.43l6.86-16H36V8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }